import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SqlCopySource } from './sql.copysource';
import { AzureSqlMITableDataset } from 'app/model/dataset/azure-sql-mi-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureSqlMI.copySourceType,
    display: [],
    tags: { datasetModel: [Metamodel.modelFor(AzureSqlMITableDataset)] }
})
export class SqlMICopySource extends SqlCopySource {
}
